import { createHash } from "crypto";
//#region src/setup-marker.ts
/**
* Setup completion marker shared by repo templates and their consumers.
*
* A repo template writes this file beside the checkout as its last build
* step, so it exists only in images where every setup command succeeded. Its
* content is a digest of the setup commands the image ran, letting a sandbox
* booted from the image tell whether the setup it is about to run already
* happened. Relative to the template's build cwd, which is also the runtime
* working directory the repo was cloned into.
*/
const SETUP_MARKER_PATH = ".mastra-sandbox/setup";
/** Blank entries never become build steps, so they never count toward the digest either. */
function normalizeSetupCommands(setupCommand) {
	return (setupCommand === void 0 ? [] : Array.isArray(setupCommand) ? setupCommand : [setupCommand]).filter((command) => command.trim() !== "");
}
/** The marker content for a setup command list: `sha256:<hex>` over the commands joined by newlines. */
function setupMarkerContent(setupCommand) {
	return `sha256:${createHash("sha256").update(normalizeSetupCommands(setupCommand).join("\n")).digest("hex")}`;
}
/** Shell step that writes the marker relative to the cwd. `content` is a digest, so it is shell-safe. */
function setupMarkerCommand(content) {
	return `mkdir -p "$(dirname "${SETUP_MARKER_PATH}")" && printf '%s' '${content}' > "${SETUP_MARKER_PATH}"`;
}
//#endregion
//#region src/repo-clone.ts
function repoCloneCommand({ cloneUrl, destination, branch, tokenEnv }) {
	return `git ${tokenEnv ? `${gitAuthFlag(tokenEnv)} ` : ""}clone --depth=1 --single-branch ${branch ? `--branch ${shellQuote(branch)} ` : ""}${shellQuote(cloneUrl)} ${shellQuote(destination)}`;
}
/** Per-invocation auth header; `-c` config never reaches `.git/config`. */
function gitAuthFlag(tokenEnv) {
	return `-c http.extraheader="AUTHORIZATION: basic $(printf 'x-access-token:%s' "$${tokenEnv}" | base64 -w0)"`;
}
function shellQuote(value) {
	return `'${value.replace(/'/g, `'\\''`)}'`;
}
//#endregion
export { SETUP_MARKER_PATH, normalizeSetupCommands, repoCloneCommand, setupMarkerCommand, setupMarkerContent };

//# sourceMappingURL=index.js.map